function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { SettingsCallToActionQuery } from "@custom/schema";
import { useEffect, useState } from "react";
import { isTruthy } from "./isTruthy";
import { useLocalization } from "./localization";
import { useOperation } from "./operation";
import { getTranslatedUrl } from "./url";
export function useCallToAction(buttonLevel) {
  var _useLocalization = useLocalization(),
    currentLocale = _useLocalization.locale;
  var _useState = _sliced_to_array(useState(), 2),
    callToActionButton = _useState[0],
    setCallToActionButton = _useState[1];
  var _useOperation = useOperation(SettingsCallToActionQuery),
    settings = _useOperation.data;
  useEffect(function () {
    if (!(settings === null || settings === void 0 ? void 0 : settings.settingsCallToAction)) {
      return;
    }
    switch (buttonLevel) {
      case "primary":
        if (settings.settingsCallToAction.primaryButtonType) {
          var _settings_settingsCallToAction_primaryButtonLink_translations, _settings_settingsCallToAction_primaryButtonLink, _settings_settingsCallToAction;
          var type = settings.settingsCallToAction.primaryButtonType;
          var url = getTranslatedUrl({
            urlObject: ((_settings_settingsCallToAction = settings.settingsCallToAction) === null || _settings_settingsCallToAction === void 0 ? void 0 : (_settings_settingsCallToAction_primaryButtonLink = _settings_settingsCallToAction.primaryButtonLink) === null || _settings_settingsCallToAction_primaryButtonLink === void 0 ? void 0 : (_settings_settingsCallToAction_primaryButtonLink_translations = _settings_settingsCallToAction_primaryButtonLink.translations) === null || _settings_settingsCallToAction_primaryButtonLink_translations === void 0 ? void 0 : _settings_settingsCallToAction_primaryButtonLink_translations.filter(isTruthy)) || [],
            langcode: currentLocale
          });
          setCallToActionButton({
            type: type,
            url: url
          });
        }
        break;
      case "secondary":
        if (settings.settingsCallToAction.secondaryButtonType) {
          var _settings_settingsCallToAction_secondaryButtonLink_translations, _settings_settingsCallToAction_secondaryButtonLink, _settings_settingsCallToAction1;
          var type1 = settings.settingsCallToAction.secondaryButtonType;
          var url1 = getTranslatedUrl({
            urlObject: ((_settings_settingsCallToAction1 = settings.settingsCallToAction) === null || _settings_settingsCallToAction1 === void 0 ? void 0 : (_settings_settingsCallToAction_secondaryButtonLink = _settings_settingsCallToAction1.secondaryButtonLink) === null || _settings_settingsCallToAction_secondaryButtonLink === void 0 ? void 0 : (_settings_settingsCallToAction_secondaryButtonLink_translations = _settings_settingsCallToAction_secondaryButtonLink.translations) === null || _settings_settingsCallToAction_secondaryButtonLink_translations === void 0 ? void 0 : _settings_settingsCallToAction_secondaryButtonLink_translations.filter(isTruthy)) || [],
            langcode: currentLocale
          });
          setCallToActionButton({
            type: type1,
            url: url1
          });
        }
        break;
    }
  }, [setCallToActionButton, buttonLevel, currentLocale, settings === null || settings === void 0 ? void 0 : settings.settingsCallToAction]);
  return callToActionButton;
}